module.exports = __webpack_public_path__ + "static/assets/co2-status.74180ae3.png";